module.exports = __webpack_public_path__ + "img/card-i4.335b3e7a.png";